LocalStorageModel = require 'app/scripts/view-models/internal/local-storage-model'

# Label state is global across the application
module.exports = new class extends LocalStorageModel
  constructor: ->
    super
    @set({ id: "labelState" })
    @fetch()
    @enableTabSync()

  default: ->
    showText: false

  getShowText: -> @get('showText')
  setShowText: (showText) -> @update('showText', showText)
  toggleText: -> @setShowText(!@getShowText())

  onStorage: (ev) ->
    @setShowText(@getShowText())
